// import { useState } from "react";
// import useFetch from "./useFetch";
// import { CircularProgress } from "@mui/material";
// import AudioListContent from "./newComponents/AudioListContent";
// import hbricon from "./otherImg/hrmwlitelogo.png";


const AudioMessages = () => {
    // const [searchAudio,setSearchAudio]=useState("");
    // const [showSearch,setShowSearch]=useState(false);
    // const {data:horemowaudiomessages,ispending,erroralert} = useFetch(`${process.env.REACT_APP_AUDIO_MESSAGE_URL}/audioMessage`);

    return ( 
        <div className="audiomsgviewcomp">
            <h2>This page is under maintenance. Check back later.</h2>
             {/* {erroralert && <div>{erroralert}</div>}
             {ispending &&
            <div style={{
                position:"absolute",
                left:"50%",
                top:"30%"
                }}> 
             <CircularProgress/> <br/>
            loading...
            </div>
            }  

            <div className="searchaudiomainpage">
                <h4 
                style={{
                color: "black",
                fontWeight: "bold" 
                }}
                >Audio messages <span style={{color:"orangered"}}>{horemowaudiomessages && horemowaudiomessages.length}</span>
                </h4>

                <input type="search" placeholder="search" onChange={e => setSearchAudio(e.target.value)}/> 
             
                <div className="pagetoplogo flex-row2">
                          <h3>HbrSoftTeam</h3>
                        <img src={hbricon} alt=""/>
                </div> 
                
            </div>

            <div className="searchaudiomainpagephone">
                <h4 
                style={{
                color: "black",
                fontWeight: "bold" 
                }}
                >{horemowaudiomessages && horemowaudiomessages.length}
                </h4>
                {showSearch ? 
                <div className="flex-row2" style={{width:"80%"}}>
                    <input type="search" placeholder="search" onChange={e => setSearchAudio(e.target.value)}/> 
                    <svg
                    onClick={()=>setShowSearch(false)}
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    height="1.5em"
                    width="1.5em">
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                  </svg>
                </div>
         
                    :
                    <svg
                    onClick={()=>setShowSearch(true)}
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    height="1.5em"
                    width="1.5em">
                    <path d="M10 18a7.952 7.952 0 004.897-1.688l4.396 4.396 1.414-1.414-4.396-4.396A7.952 7.952 0 0018 10c0-4.411-3.589-8-8-8s-8 3.589-8 8 3.589 8 8 8zm0-14c3.309 0 6 2.691 6 6s-2.691 6-6 6-6-2.691-6-6 2.691-6 6-6z" />
                  </svg>
                }
                {!showSearch && 
                    <div className="pagetoplogo flex-row2">
                         <h4>HBR <span style={{color:"orangered",fontWeight:"bold"}}>LiTE</span></h4> 
                       <img src={hbricon} alt=""/>
                    </div> 
                }
             
                
            </div>
            
            <div className="audiodatasubcompmain">
                {horemowaudiomessages && horemowaudiomessages.filter((audioData)=>{
                if(searchAudio === ""){
                    return true;
                }else if(audioData.title.replace(/[^\w\s]|_/g, '').toLowerCase().includes(searchAudio.toLowerCase())){
                    return true;
                }
                    return false;

                }).map((audioData) => (
                    <AudioListContent
                        key={audioData.id}
                        audioID = {audioData.id}
                        audioTitle = {audioData.title}
                    />
                ))
                }
            </div> 
            
            <div className="audiodatasubphone">
                {horemowaudiomessages && horemowaudiomessages.filter((audioData)=>{
                if(searchAudio === ""){
                    return true;
                }else if(audioData.title.replace(/[^\w\s]|_/g, '').toLowerCase().includes(searchAudio.toLowerCase())){
                    return true;
                }
                    return false;

                }).map((audioData) => (
                    <AudioListContent
                        key={audioData.id}
                        audioID = {audioData.id}
                        audioTitle = {audioData.title}
                    />
                ))
                }
            </div>  */}

        </div>
     );
}
export default AudioMessages;